/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconChatNote.vue?vue&type=template&id=59631499&scoped=true"
import script from "./IconChatNote.vue?vue&type=script&lang=js"
export * from "./IconChatNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59631499",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59631499')) {
      api.createRecord('59631499', component.options)
    } else {
      api.reload('59631499', component.options)
    }
    module.hot.accept("./IconChatNote.vue?vue&type=template&id=59631499&scoped=true", function () {
      api.rerender('59631499', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconChatNote.vue"
export default component.exports